import React from 'react';
import { useParams } from 'react-router-dom';
import { OpenDirectoryButton } from '../../common/OpenDirectoryButton';
import { path } from '../../paths';
import { useNavigateTo } from '../../paths/useNavigateTo';
import { OUTPUT_DATA_OBJECT_ROUTES } from './OutputDataObjects';
import { DataObjectDetails } from '../data-objects/DataObjectDetails';
import { DataObjectView } from '@atlas-frontend/sdk';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './OutputDataObjectDetails.translations.json';

const { addTranslations, useTranslation } = i18nNsFactory(
  'output-data-object-details',
);
addTranslations(translations);

export const OutputDataObjectDetails = () => {
  const { id } = useParams() as { id: string | number };
  const { t } = useTranslation();

  const navigateToDetails = useNavigateTo(path.outputDataObjectView, { id });
  const navigateToEdit = useNavigateTo(path.outputDataObjectEdit, { id });
  const navigateToClone = useNavigateTo(path.outputDataObjectClone, { id });
  const navigateToDirectory = useNavigateTo(path.outputDataObjectDirectory);

  return (
    <DataObjectDetails
      routes={OUTPUT_DATA_OBJECT_ROUTES}
      view={DataObjectView.OUT}
      navigateToDetails={navigateToDetails}
      navigateToEdit={navigateToEdit}
      navigateToClone={navigateToClone}
      navigateToDirectory={navigateToDirectory}
      actions={
        <OpenDirectoryButton
          options={[
            {
              id: 'outputDataObjectDirectory',
              path: path.outputDataObjectDirectory,
              label: t('button.outputDataObjectDirectory'),
            },
          ]}
        />
      }
    />
  );
};
